import React, {useState, useCallback } from 'react';

import { api_getCategories } from '../../../api/category';
import { useNavigate } from 'react-router-dom';
import { api_createProduct } from '../../../api/product';
import { AsyncPaginate } from 'react-select-async-paginate';
import { myToastWarning } from '../../../helpers/myToast';
import { toast } from 'react-hot-toast';

export const SelectAsyncPaginate = ({
	value,
	onChange,
	loadOptions,
}: {
	value: any;
	onChange: any;
	loadOptions: any;
}) => {
	return (
		<AsyncPaginate
			value={value}
			loadOptions={loadOptions}
			getOptionValue={(option) => option._id}
			getOptionLabel={(option) => option.name}
			onChange={onChange}
			isSearchable={false}
			placeholder='Select Category'
			additional={{
				page: 1,
			}}
		/>
	);
};

const AddProduct = () => {
	const [loading, setLoading] = useState<boolean>(false);
	const [image, setImage] = useState<any>(null);
	const [name, setName] = useState('');
	const [quantity, setQuantity] = useState<string | number>('1');
	const [onSalePrice, setOnSalePrice] = useState<string | number>('1');
	const [retailPrice, setRetailPrice] = useState<string | number>('1');
	const [des, setDes] = useState('');
	// const [address, setAddres] = useState('');
	const [selectedCategory, setSelectedCategory] = useState<any>(null);
	const [selectedSubCategory, setSelectedSubCategory] = useState<any>(null);
	const [selectedSubSubCategory, setSelectedSubSubCategory] = useState<any>(null);
	const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState<any>(null);

	const loadOptions = useCallback(async (additional = { page: 1 }) => {
		const { page } = additional;
		const res = await api_getCategories(page, 10);
		return {
			options: res.data,
		};
	}, []);

	const loadSubCategory = useCallback(
		async (additional = { page: 1 }) => {
			const { page } = additional;
			const res = selectedCategory?.subCategories || [];
			return {
				options: res,
			};
		},
		[selectedCategory],
	);
	const loadSubSubCategory = useCallback(
		async (additional = { page: 1 }) => {
			const { page } = additional;
			const res = selectedSubCategory?.subSubCategories || [];
			return {
				options: res,
			};
		},
		[selectedSubCategory],
	);

	const loadSubSubSubCategory = useCallback(
		async (additional = { page: 1 }) => {
			const { page } = additional;
			const res = selectedSubSubCategory?.subSubSubCategories || [];
			return {
				options: res,
			};
		},
		[selectedSubSubCategory],
	);

	const navigate = useNavigate();
	const create = async () => {
		if (image === null) {
			myToastWarning('Please Pick Image');
			return;
		}
		if (!quantity) {
			myToastWarning('Please Enter Quantity');
			return;
		}
		if (!name) {
			myToastWarning('Please Enter Name');
			return;
		}
		if (!retailPrice) {
			myToastWarning('Please Enter Br Price');
			return;
		}
		if (!onSalePrice) {
			myToastWarning('Please Enter USD Price');
			return;
		}

		try {
			setLoading(true);
			const payload = new FormData();
			payload.append('name', name);
			payload.append('description', des);
			payload.append('address', '');

			// @ts-ignore
			payload.append('quantity', quantity);

			// LOCAL PRICE
			// @ts-ignore
			payload.append('retailPrice.amount', Number(retailPrice));
			payload.append('retailPrice.currency', 'local');
			payload.append('retailPrice.prefix', 'Br');
			// GLOBAL PRICE
			// @ts-ignore
			payload.append('onSalePrice.amount', Number(onSalePrice));
			payload.append('onSalePrice.currency', 'globaly');
			payload.append('onSalePrice.prefix', '$');

			if (selectedCategory) {
				payload.append('category.main', selectedCategory._id);
			}
			if (selectedSubCategory) {
				payload.append('category.sub', selectedSubCategory._id);
			}
			if (selectedSubSubCategory) {
				payload.append('category.subsub', selectedSubSubCategory._id);
			}
			if (selectedSubSubSubCategory) {
				payload.append('category.subsubsub', selectedSubSubSubCategory._id);
			}
			payload.append('image', image);
			const res = await api_createProduct(payload);
			const message = typeof res.message === 'string' ? res.message : 'Success';
			const errorMessage =
				typeof res.message === 'string' ? res.message : 'Failed to create product';

			if (res.isSuccess) {
				toast.success(message);
				setTimeout(() => {
					navigate(-1);
				}, 100);
			} else {
				toast.error(errorMessage);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyItems: 'center',
				alignItems: 'center',
				flex: 1,
				padding: '40px',
			}}>
			<div className='mb-3'>
				<h3>Add Product</h3>
			</div>

			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Name
				</label>
				<input
					value={name}
					onChange={(e) => setName(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Price In Dollar
				</label>
				<input
					value={onSalePrice}
					type='number'
					onChange={(e) => setOnSalePrice(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Price In Ethiopian Birr
				</label>
				<input
					value={retailPrice}
					type='number'
					onChange={(e) => setRetailPrice(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='exampleFormControlInput1' className='form-label'>
					Qty
				</label>
				<input
					value={quantity}
					type='number'
					onChange={(e) => setQuantity(Number(e.target.value))}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlInput1'
					placeholder=''
				/>
			</div>
			<div className='mb-3'>
				<label htmlFor='formFileSm' className='form-label'>
					Product Image
				</label>
				<input
					onChange={(event) => {
						// @ts-ignore

						setImage(event.target.files[0]);
					}}
					style={{ width: '400px' }}
					className='form-control form-control-sm'
					id='formFileSm'
					type='file'
				/>
			</div>
			<div className='mb-3' style={{ width: '400px' }}>
				<label htmlFor='formFileSm' className='form-label'>
					Product Category
				</label>

				<SelectAsyncPaginate
					onChange={setSelectedCategory}
					value={selectedCategory}
					loadOptions={loadOptions}
				/>
			</div>

			{selectedCategory &&
				selectedCategory?.subCategories &&
				selectedCategory?.subCategories.length > 0 && (
					<div className='mb-3' style={{ width: '400px' }}>
						<label htmlFor='formFileSm' className='form-label'>
							Sub Product Category
						</label>

						<SelectAsyncPaginate
							onChange={setSelectedSubCategory}
							value={selectedSubCategory}
							loadOptions={loadSubCategory}
						/>
					</div>
				)}
			{selectedSubCategory &&
				selectedSubCategory?.subSubCategories &&
				selectedSubCategory?.subSubCategories.length > 0 && (
					<div className='mb-3' style={{ width: '400px' }}>
						<label htmlFor='formFileSm' className='form-label'>
							Sub Sub Product Category
						</label>

						<SelectAsyncPaginate
							onChange={setSelectedSubSubCategory}
							value={selectedSubSubCategory}
							loadOptions={loadSubSubCategory}
						/>
					</div>
				)}
			{selectedSubSubCategory &&
				selectedSubSubCategory?.subSubSubCategories &&
				selectedSubSubCategory?.subSubSubCategories.length > 0 && (
					<div className='mb-3' style={{ width: '400px' }}>
						<label htmlFor='formFileSm' className='form-label'>
							Sub Sub Sub Product Category
						</label>

						<SelectAsyncPaginate
							onChange={setSelectedSubSubSubCategory}
							value={selectedSubSubSubCategory}
							loadOptions={loadSubSubSubCategory}
						/>
					</div>
				)}
			<div className='mb-3'>
				<label htmlFor='exampleFormControlTextarea1' className='form-label'>
					Description
				</label>
				<textarea
					value={des}
					onChange={(e) => setDes(e.target.value)}
					style={{ width: '400px' }}
					className='form-control'
					id='exampleFormControlTextarea1'
					rows={3}></textarea>
			</div>
			<button
				onClick={create}
				type='button'
				className='btn btn-lg btn-primary'
				disabled={loading}>
				{loading ? 'Loading..' : 'Submit'}
			</button>
		</div>
	);
};

export default AddProduct;
